import React = require('react');
import { Modal, Radio } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { IAuthState } from '../../services/auth/models';
import { filter, get, head } from 'lodash';
import { IQuoteActions } from '../../services/quote/models';
import { BsInfoCircle } from 'react-icons/bs';
import { toastr } from 'react-redux-toastr';
import { IProduct } from '../../data/api/models';

interface IOptInForRenewalModalProps {
  auth: IAuthState;
  actions: IQuoteActions;
  product: IProduct;
}

export const OptInForRenewalModal = ({ auth, actions, product }: IOptInForRenewalModalProps) => {

  const [showModal, setShowModal] = useState(false);
  const [policy, setPolicy] = useState(null);
  const [renewalType, setRenewalType] = useState(null);
  const allowedChannelNames = ['MoneySuperMarket', 'TravelSupermarket']

  useEffect(() => {
    const activePolicies = get(auth, 'customer.activePolicies');
    const annualPolicies = filter(activePolicies, ['metadata.scheme_type', 'annual']);
    const isEnabled = get(product, 'metadata.direct_customer_mta_options.change_renewal_status.enabled', false)

    if (!isEnabled) {
      return;
    }

    if ((activePolicies && activePolicies.length >= 2)) {
      return;
    }

    const activePolicy = head(annualPolicies);

    if (!activePolicy) {
      return;
    }

    const alreadyUpdated = get(activePolicy, 'metadata.portal_changed_renewal_status', false);
    if (alreadyUpdated) {
      return;
    }

    const channelName = get(activePolicy, 'channelName')

    if (channelName && allowedChannelNames.includes(channelName)) {
      Promise.resolve(actions.getPolicyInfo(activePolicy.id)).then((data) => {
        if (get(data, 'meta.hasRenewal')) {
          return;
        }
        if (get(data, 'meta.termNumber', 0) !== 1) {
          return;
        }
        setPolicy(activePolicy)
        setShowModal(true)
      })
    }
  }, []);

  const onCloseModal = () => {
    setShowModal(false)
  }

  const handleRadioChange = (event) => {
    const renewalType = get(event, 'target.value');
    if (renewalType) {
      setRenewalType(renewalType)

      const data = {
        renewal_status: renewalType,
        flag_to_meta: {
          portal_changed_renewal_status: true
        }
      }
      Promise.resolve(actions.updatePolicy(policy.id, data))
        .then((data) => {
          setShowModal(false)
          toastr.success('Policy renewal status updated');
        })
        .catch((error) => {
          setShowModal(false)
          toastr.error('There has been an issue updating your renewal status, pls contact us');
        })
    }
  }

  const auto = 'auto';
  const manual = 'manual';

  return (
    <Modal show={showModal} onHide={onCloseModal} backdrop={'static'} style={{top: '25%'}}>
      <Modal.Body className={'opt-in-modal-body'}>
        <div className={'optIn-details-info'}>
          <div>
            <p style={{opacity: '50%'}}><span className={'info-icon'}><BsInfoCircle/></span>We see <b>you haven't set your renewal
              preferences</b> with Admiral yet. By choosing auto-renewal you will be able to <b>save time</b> next year
              and ensure you are <b>continuously protected!</b></p>
          </div>
          <div className={'radio-group-opt radio-group-renewal auto'}>
            <div className={'radio-opt'}>
              <Radio
                id={'optIn'}
                value={auto}
                className="radio-opt-text-auto"
                onChange={handleRadioChange}
                checked={renewalType === auto}
              >
                <div/>
                <span style={{ paddingLeft: '15px', fontWeight: 'bold' }}>
                  {'Auto-renewal on'}
                </span>
              </Radio>
            </div>
            <div className={'radio-opt manual'}>
              <Radio
                id={'optOut'}
                value={manual}
                className={'radio-opt-text-manual'}
                onChange={handleRadioChange}
                checked={renewalType === manual}
              >
                <div/>
                <span style={{ paddingLeft: '15px', opacity: '50%' }}>
                     {'Auto-renewal off'}
                  </span>
              </Radio>
            </div>
          </div>
          <div style={{opacity: '50%'}}>
            <p style={{ fontWeight: 'normal'}}>To keep you protected your policy can be set to renew automatically using the payment details you
              provide. You can change your auto-renewal preference at any time for free during your policy term by
              contacting us by phone or online.
            </p>
            <p>Before automatically renewing we will send you a renewal notice in advance so that you can review the new
              premium and cover details and have an opportunity to shop around. If you don't wish to accept tge renewal
              offer at the time just let us know then and we can make sure no payment is taken.</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}
